var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOsmosis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_389_1559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.8159 8.10355C41.3727 6.42586 39.9482 4.74816 37.3842 2.88053C35.3266 1.39276 33.1425 0.538086 31.4015 0.538086C31.0533 0.538086 30.7367 0.569741 30.4202 0.63305C29.6288 0.791323 28.9324 1.36111 28.4892 2.21578C27.9511 3.22873 27.8245 4.58989 28.1727 5.41291C28.2993 5.66614 28.4576 5.98269 28.6475 6.26758C26.9698 7.28053 26.0202 7.56542 25.8936 7.59708C30.2619 9.05319 33.9022 12.092 36.1813 16.0489L36.213 15.669C36.3079 14.6244 36.6245 13.4215 37.0677 12.187C37.5108 12.3136 37.954 12.3769 38.3972 12.3769C39.5684 12.3769 40.5813 11.9021 41.2144 11.0474C41.8475 10.1928 42.1007 9.05319 41.8159 8.10355Z",
    fill: "#5E12A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2575 11.269C40.1381 12.0604 41.3093 9.84452 40.9295 8.35675C40.5179 6.86898 39.1884 5.34956 36.846 3.64021C34.5036 1.93085 32.1295 1.23445 30.61 1.551C29.0906 1.86754 28.6474 4.17834 29.0273 5.06467C29.1856 5.41287 29.5338 5.91934 30.0086 6.48913C29.4072 6.90064 28.8374 7.21719 28.3625 7.50208C31.2748 8.79992 33.8072 10.8258 35.7064 13.3582C35.928 12.5035 36.2446 11.7438 36.5295 11.0791C36.751 11.1107 37.0043 11.174 37.2575 11.269Z",
    fill: "url(#paint0_radial_389_1559)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7655 42.2906C30.5383 42.2906 38.4605 34.3683 38.4605 24.5956C38.4605 14.8229 30.5383 6.90063 20.7655 6.90063C10.9928 6.90063 3.07056 14.8229 3.07056 24.5956C3.07056 34.3683 10.9928 42.2906 20.7655 42.2906Z",
    fill: "url(#paint1_radial_389_1559)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4734 6.90068C37.0676 4.3683 35.0417 3.70355 32.6043 3.16542C30.705 2.72226 31.2115 1.646 33.5223 1.86758C32.4144 1.48773 31.3698 1.39276 30.6101 1.55104C29.0906 1.86758 28.6475 4.17837 29.0273 5.0647C29.1856 5.41291 29.5338 5.91938 30.0086 6.48916C29.154 7.05895 28.4259 7.47046 27.8245 7.78701C28.1094 7.91363 28.4576 8.0719 28.8691 8.29348C29.9453 8.86327 31.1165 9.81291 31.1165 9.81291C29.3439 8.29348 29.7237 7.59708 32.1612 5.88773C32.9209 5.3496 34.3137 5.41291 35.6115 6.07765C36.9094 6.7424 38.4288 8.4201 38.4288 8.4201L36.9727 11.2057C37.0676 11.2374 37.1626 11.269 37.2576 11.3007C38.1755 11.5539 38.9036 11.4906 39.4734 11.269C40.1381 10.8575 41.8791 9.4647 39.4734 6.90068Z",
    fill: "#A98698",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5727 4.68485C33.2058 4.93809 34.0288 5.38125 35.0417 6.046C36.2446 6.83737 37.2892 7.7237 37.954 8.4201C36.8461 9.87621 36.118 11.8705 35.6748 13.2633C35.8964 13.5798 36.1496 13.8964 36.3712 14.2129C36.5928 13.4215 36.9727 12.2503 37.4791 11.0791C37.6058 11.1107 37.764 11.1107 37.9223 11.1107C38.3022 11.1107 38.7453 11.0474 39.0935 10.7625C39.3468 10.5726 39.6317 10.2244 39.6 9.59132C39.6 8.98988 39.1252 8.23017 38.1439 7.31219C37.4475 6.64744 36.4979 5.91938 35.5482 5.25463C32.8259 3.45032 30.9266 2.94384 30.0719 3.79852C29.5022 4.3683 29.5655 5.0647 29.7554 5.57118C28.7425 6.23593 27.8878 6.71075 27.318 7.02729C27.6978 7.15391 28.0461 7.31219 28.4259 7.47046C29.4389 6.93233 30.895 6.01434 32.5727 4.68485ZM38.5554 9.21147C38.6504 9.36974 38.682 9.52801 38.682 9.62298C38.682 9.90787 38.5871 10.0028 38.5237 10.0661C38.3971 10.1611 38.1439 10.2244 37.9223 10.2244C38.1122 9.84456 38.3338 9.52801 38.5554 9.21147ZM30.7367 4.49492C30.8317 4.39996 31.0849 4.33665 31.4964 4.39996C31.1799 4.65319 30.8633 4.87478 30.5468 5.09636C30.5151 4.87478 30.5468 4.65319 30.7367 4.49492Z",
    fill: "#5E12A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7654 5.8562C10.4144 5.8562 2.02588 14.2447 2.02588 24.5958C2.02588 34.9469 10.4144 43.3353 20.7654 43.3353C31.1165 43.3353 39.505 34.9469 39.505 24.5958C39.505 14.2447 31.0849 5.8562 20.7654 5.8562ZM20.7654 42.2907C10.9842 42.2907 3.07048 34.3771 3.07048 24.5958C3.07048 14.8145 10.9842 6.90081 20.7654 6.90081C30.5467 6.90081 38.4604 14.8145 38.4604 24.5958C38.4604 34.3771 30.5151 42.2907 20.7654 42.2907Z",
    fill: "#5E12A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7655 42.2906C30.5383 42.2906 38.4605 34.3683 38.4605 24.5956C38.4605 14.8229 30.5383 6.90063 20.7655 6.90063C10.9928 6.90063 3.07056 14.8229 3.07056 24.5956C3.07056 34.3683 10.9928 42.2906 20.7655 42.2906Z",
    fill: "url(#paint2_linear_389_1559)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6389 40.1381C10.9842 38.587 4.43167 29.5021 6.01441 19.8474C6.71081 15.574 8.86333 11.9337 11.9022 9.3064C7.47052 11.8704 4.17844 16.3337 3.29211 21.7783C1.74103 31.433 8.29354 40.5179 17.9166 42.069C23.2979 42.9553 28.4892 41.2776 32.3194 37.9855C28.9324 39.9481 24.8173 40.8028 20.6389 40.1381Z",
    fill: "#A98698",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5827 7.15385C19.1194 6.4258 14.7827 7.43875 11.2374 9.68623C11.1741 9.74954 11.1108 9.81285 11.1108 9.81285C12.4719 8.98983 14.4662 8.26177 14.4662 8.26177C9.33811 11.2373 7.75537 14.6244 7.75537 14.6244C9.74962 10.7625 15.6057 8.04018 20.1957 7.85026C24.7856 7.66033 27.7928 9.02148 31.4647 11.9654C35.1367 14.9409 37.3525 21.0186 37.1309 25.8301C36.941 30.6416 34.4086 34.5351 34.4086 34.5351C36.1496 32.2877 37.1942 30.6416 37.859 28.9639C37.9856 28.4575 38.1122 27.951 38.1755 27.4128C39.7583 17.7898 33.2374 8.70493 23.5827 7.15385Z",
    fill: "url(#paint3_linear_389_1559)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5741 24.4375C37.5741 33.7123 30.0403 41.2461 20.7655 41.2461C11.4906 41.2461 3.92517 33.7123 3.92517 24.4375H37.5741Z",
    fill: "url(#paint4_linear_389_1559)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2446 24.4375C36.2446 33.4907 29.0906 40.8979 20.1007 41.2461H20.7655C30.0403 41.2461 37.5741 33.7123 37.5741 24.4375H36.2446Z",
    fill: "url(#paint5_linear_389_1559)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.29927 24.4375H3.92517C3.92517 33.7123 11.459 41.2461 20.7338 41.2461C21.1453 41.2461 21.5252 41.2461 21.905 41.2145C13.2 40.5814 6.29927 33.3008 6.29927 24.4375Z",
    fill: "url(#paint6_linear_389_1559)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5424 24.5957C37.5424 22.6648 34.187 21.5569 29.7237 21.177C26.495 20.9238 23.2345 21.2403 19.4993 22.3799C16.2705 23.3296 13.3583 23.1713 11.2374 22.918C6.52085 22.3799 3.92517 22.3166 3.92517 24.5957C3.92517 27.8878 10.636 32.0029 20.7022 30.5785C25.7986 29.8504 28.4259 28.3626 31.4331 27.3497C34.6935 26.2734 37.5424 26.3051 37.5424 24.5957Z",
    fill: "url(#paint7_linear_389_1559)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2734 16.6187C27.8469 16.6187 29.1223 15.3434 29.1223 13.7698C29.1223 12.1963 27.8469 10.9209 26.2734 10.9209C24.6998 10.9209 23.4244 12.1963 23.4244 13.7698C23.4244 15.3434 24.6998 16.6187 26.2734 16.6187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9266 18.7395C31.5911 18.7395 32.1295 18.201 32.1295 17.5366C32.1295 16.8722 31.5911 16.3337 30.9266 16.3337C30.2622 16.3337 29.7238 16.8722 29.7238 17.5366C29.7238 18.201 30.2622 18.7395 30.9266 18.7395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2317 11.4906H35.1684C34.9785 11.4589 34.8519 11.269 34.8835 11.0474C35.1684 9.59131 36.3713 8.19851 36.4346 8.1352C36.5612 7.97693 36.8144 7.97693 36.9411 8.10354C37.0993 8.23016 37.0993 8.4834 36.9727 8.61002C36.9411 8.64167 35.8332 9.93952 35.5799 11.2057C35.5483 11.3956 35.39 11.4906 35.2317 11.4906Z",
    fill: "url(#paint8_linear_389_1559)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4014 0.53813C33.1741 0.53813 35.3582 1.39281 37.3842 2.88058C39.9482 4.7482 41.3726 6.39424 41.8158 8.1036C42.069 9.08489 41.8475 10.1928 41.2144 11.0158C40.5496 11.8705 39.5683 12.3453 38.3971 12.3453C37.9856 12.3453 37.5424 12.282 37.0676 12.1554C36.7827 12.8835 36.5611 13.6115 36.4029 14.3079C38.3338 17.2518 39.4734 20.7971 39.4734 24.5957C39.4734 34.9468 31.0849 43.3353 20.7338 43.3353C10.3827 43.3353 2.02588 34.9468 2.02588 24.5957C2.02588 14.2446 10.4144 5.85612 20.7654 5.85612C23.0446 5.85612 25.2288 6.26763 27.2547 7.02734C27.6345 6.83741 28.1093 6.58417 28.6475 6.26763C28.4575 5.98273 28.2676 5.69784 28.1726 5.41295C27.8244 4.55827 27.9511 3.22878 28.4892 2.21583C28.9324 1.39281 29.5971 0.823022 30.4201 0.633094C30.705 0.569784 31.0532 0.53813 31.4014 0.53813ZM31.4014 0C31.0216 0 30.6417 0.0316547 30.2935 0.126619C29.3439 0.348201 28.5208 0.981295 27.9827 1.99424C27.3813 3.16547 27.223 4.68489 27.6345 5.66619C27.6978 5.79281 27.7611 5.95108 27.8561 6.10935C27.6345 6.23597 27.4129 6.36259 27.1913 6.45755C25.1021 5.7295 22.9496 5.34964 20.7338 5.34964C18.1381 5.34964 15.6057 5.85612 13.2316 6.86907C10.9208 7.85036 8.86329 9.24317 7.09063 11.0158C5.31796 12.7885 3.92516 14.846 2.94386 17.1568C1.93091 19.5309 1.42444 22.0633 1.42444 24.659C1.42444 27.2547 1.93091 29.7871 2.94386 32.1612C3.92516 34.4719 5.31796 36.5295 7.09063 38.3022C8.86329 40.0748 10.9208 41.4676 13.2316 42.4489C15.6057 43.4619 18.1381 43.9683 20.7338 43.9683C23.3295 43.9683 25.8618 43.4619 28.2359 42.4489C30.5467 41.4676 32.6043 40.0748 34.377 38.3022C36.1496 36.5295 37.5424 34.4719 38.5237 32.1612C39.5367 29.7871 40.0431 27.2547 40.0431 24.659C40.0431 20.9554 38.9985 17.3784 37.0043 14.2763C37.0993 13.8014 37.2575 13.3266 37.4158 12.8518C37.7324 12.9151 38.0806 12.9468 38.3971 12.9468C39.7266 12.9468 40.8978 12.4086 41.6575 11.3957C42.3856 10.446 42.6705 9.11655 42.3539 8.00863C41.8475 6.17266 40.3913 4.43165 37.7007 2.50072C35.5798 0.886331 33.269 0 31.4014 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5942 37.7956C20.0836 37.7956 20.4805 37.3987 20.4805 36.9093C20.4805 36.4199 20.0836 36.0229 19.5942 36.0229C19.1048 36.0229 18.7079 36.4199 18.7079 36.9093C18.7079 37.3987 19.1048 37.7956 19.5942 37.7956Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0877 37.4791C18.7395 37.1309 18.7395 36.5612 19.0877 36.213C19.151 36.1497 19.2143 36.118 19.2776 36.0547C19.151 36.0863 19.0561 36.1497 18.9611 36.2446C18.6129 36.5928 18.6129 37.1626 18.9611 37.5108C19.246 37.7957 19.6892 37.859 20.0374 37.6691C19.7208 37.7957 19.341 37.7324 19.0877 37.4791Z",
    fill: "url(#paint9_linear_389_1559)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9108 36.6562C20.0155 36.6562 20.1007 36.5711 20.1007 36.4663C20.1007 36.3615 20.0155 36.2764 19.9108 36.2764C19.806 36.2764 19.7208 36.3615 19.7208 36.4663C19.7208 36.5711 19.806 36.6562 19.9108 36.6562Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2158 37.3525C24.7052 37.3525 25.1021 36.9555 25.1021 36.4662C25.1021 35.9768 24.7052 35.5798 24.2158 35.5798C23.7264 35.5798 23.3295 35.9768 23.3295 36.4662C23.3295 36.9555 23.7264 37.3525 24.2158 37.3525Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7093 37.036C23.3611 36.6878 23.3611 36.118 23.7093 35.7698C23.7726 35.7065 23.8359 35.6749 23.8992 35.6116C23.7726 35.6432 23.6776 35.7065 23.5827 35.8015C23.2345 36.1497 23.2345 36.7195 23.5827 37.0677C23.8676 37.3526 24.3107 37.4159 24.6589 37.226C24.3424 37.3526 23.9625 37.2893 23.7093 37.036Z",
    fill: "url(#paint10_linear_389_1559)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5323 36.2129C24.6371 36.2129 24.7223 36.1277 24.7223 36.0229C24.7223 35.9182 24.6371 35.833 24.5323 35.833C24.4276 35.833 24.3424 35.9182 24.3424 36.0229C24.3424 36.1277 24.4276 36.2129 24.5323 36.2129Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9367 39.4101C22.3039 39.4101 22.6015 39.1125 22.6015 38.7453C22.6015 38.3781 22.3039 38.0806 21.9367 38.0806C21.5695 38.0806 21.272 38.3781 21.272 38.7453C21.272 39.1125 21.5695 39.4101 21.9367 39.4101Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5569 39.1569C21.3036 38.9037 21.3036 38.4605 21.5569 38.2073C21.5885 38.1756 21.6518 38.144 21.6835 38.1123C21.5885 38.144 21.5252 38.2073 21.4619 38.2706C21.2087 38.5238 21.2087 38.967 21.4619 39.2202C21.6835 39.4418 22 39.4735 22.2849 39.3152C22.0317 39.4101 21.7468 39.3468 21.5569 39.1569Z",
    fill: "url(#paint11_linear_389_1559)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1582 38.5237C22.2282 38.5237 22.2849 38.4671 22.2849 38.3971C22.2849 38.3272 22.2282 38.2705 22.1582 38.2705C22.0883 38.2705 22.0316 38.3272 22.0316 38.3971C22.0316 38.4671 22.0883 38.5237 22.1582 38.5237Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0201 38.9352C26.3873 38.9352 26.6848 38.6377 26.6848 38.2705C26.6848 37.9033 26.3873 37.6057 26.0201 37.6057C25.6529 37.6057 25.3553 37.9033 25.3553 38.2705C25.3553 38.6377 25.6529 38.9352 26.0201 38.9352Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6402 38.6821C25.387 38.4288 25.387 37.9857 25.6402 37.7324C25.6719 37.7008 25.7352 37.6691 25.7669 37.6375C25.6719 37.6691 25.6086 37.7324 25.5453 37.7957C25.292 38.049 25.292 38.4921 25.5453 38.7454C25.7669 38.9669 26.0834 38.9986 26.3683 38.8403C26.1151 38.9353 25.8302 38.872 25.6402 38.6821Z",
    fill: "url(#paint12_linear_389_1559)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2417 38.0489C26.3117 38.0489 26.3684 37.9922 26.3684 37.9223C26.3684 37.8523 26.3117 37.7957 26.2417 37.7957C26.1718 37.7957 26.1151 37.8523 26.1151 37.9223C26.1151 37.9922 26.1718 38.0489 26.2417 38.0489Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8273 37.4791C16.6317 37.4791 17.2834 36.8274 17.2834 36.023C17.2834 35.219 16.6317 34.5669 15.8273 34.5669C15.0233 34.5669 14.3712 35.219 14.3712 36.023C14.3712 36.8274 15.0233 37.4791 15.8273 37.4791Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0044 36.941C14.4346 36.3712 14.4346 35.4532 15.0044 34.8834C15.0993 34.7885 15.1943 34.7252 15.3209 34.6619C15.131 34.7252 14.9727 34.8518 14.8144 34.9784C14.2446 35.5482 14.2446 36.4662 14.8144 37.036C15.2892 37.5108 16.0173 37.6057 16.5871 37.2575C16.049 37.4791 15.4159 37.3842 15.0044 36.941Z",
    fill: "url(#paint13_linear_389_1559)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3338 35.5799C16.5085 35.5799 16.6503 35.4381 16.6503 35.2633C16.6503 35.0886 16.5085 34.9468 16.3338 34.9468C16.159 34.9468 16.0172 35.0886 16.0172 35.2633C16.0172 35.4381 16.159 35.5799 16.3338 35.5799Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8375 33.9022C29.6418 33.9022 30.2936 33.2504 30.2936 32.4461C30.2936 31.6421 29.6418 30.99 28.8375 30.99C28.0334 30.99 27.3813 31.6421 27.3813 32.4461C27.3813 33.2504 28.0334 33.9022 28.8375 33.9022Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9827 33.3641C27.413 32.7943 27.413 31.8763 27.9827 31.3065C28.0777 31.2116 28.1727 31.1483 28.2993 31.085C28.1094 31.1483 27.9511 31.2749 27.7928 31.4015C27.223 31.9713 27.223 32.8893 27.7928 33.4591C28.2676 33.9339 28.9957 34.0289 29.5655 33.6806C29.0273 33.9022 28.4259 33.8073 27.9827 33.3641Z",
    fill: "url(#paint14_linear_389_1559)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3439 32.003C29.5186 32.003 29.6604 31.8612 29.6604 31.6864C29.6604 31.5117 29.5186 31.3699 29.3439 31.3699C29.1692 31.3699 29.0273 31.5117 29.0273 31.6864C29.0273 31.8612 29.1692 32.003 29.3439 32.003Z",
    fill: "white",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.3521 6.36248) scale(14.1479)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEAFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#A087C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10002F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.4811 12.3963) scale(34.6147)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEAFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#A087C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10002F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 17.9271,
    y1: 42.0395,
    x2: 23.5869,
    y2: 7.12222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81FFFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 33.2358,
    y1: 12.5784,
    x2: 18.6037,
    y2: 26.0037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 3.93942,
    y1: 32.832,
    x2: 37.5659,
    y2: 32.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0002E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF00C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 39.1578,
    y1: 25.9125,
    x2: 20.8549,
    y2: 43.2097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 3.93942,
    y1: 32.832,
    x2: 21.9294,
    y2: 32.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000292",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D00C7",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 3.96199,
    y1: 25.9921,
    x2: 37.5435,
    y2: 25.9921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE00C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 36.9923,
    y1: 7.98104,
    x2: 34.579,
    y2: 11.9031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 18.6991,
    y1: 36.9366,
    x2: 20.0383,
    y2: 36.9366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 23.3174,
    y1: 36.4875,
    x2: 24.6567,
    y2: 36.4875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 21.2678,
    y1: 38.753,
    x2: 22.2733,
    y2: 38.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 25.3375,
    y1: 38.2769,
    x2: 26.343,
    y2: 38.2769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 14.3726,
    y1: 36.0601,
    x2: 16.5597,
    y2: 36.0601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 27.3631,
    y1: 32.4822,
    x2: 29.5502,
    y2: 32.4822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_389_1559"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOsmosis);
export default __webpack_public_path__ + "static/media/osmosis.0d929a39aeb3a66ee89dd2a99b2b80dc.svg";
export { ForwardRef as ReactComponent };